import React, { type FC, useMemo } from "react";
import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import { MarketingAutomationConfigKeys } from "kadow-jetpack-model";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../designsystem/KC_Button/KC_Button";
import { LANGUAGE, tt } from "../../../utils/i18n/i18n";
import "./styles.scss";
import { BASE_URL } from "../../../utils/constants";

export type EmailTemplateKeyType =
  | MarketingAutomationConfigKeys
  | "ml_win"
  | "win"
  // leaderboard - customer of the month
  | "ltycm";

interface Props {
  maKey: EmailTemplateKeyType;
}

const EmailTemplate: FC<Props & NiceModalHocProps> = NiceModal.create<Props>(
  (props) => {
    const modal = useModal();

    const img = useMemo(() => {
      switch (props.maKey) {
        case MarketingAutomationConfigKeys.grant_tokens_15th:
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/15_du_mois.png`;

        case MarketingAutomationConfigKeys.onboarding:
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/onboarding.png`;

        case "ml_win":
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/glm_gain.png`;

        case MarketingAutomationConfigKeys.ml_loser:
        case "ml_loser":
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/glm_perdu.png`;

        case "win":
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/victoire_jour_j.png`;

        case MarketingAutomationConfigKeys.reminder:
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/reminder.png`;

        case MarketingAutomationConfigKeys.birthday:
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/birthday.png`;

        case "ltycm":
          return `${BASE_URL}/img/mktgauto/${LANGUAGE || "en"}/customer_of_the_month.png`;

        default:
          return "";
      }
    }, [props.maKey]);

    return (
      <KC_Modal_2
        isOpen={modal.visible}
        onClose={modal.hide}
        footer={
          <div>
            <KC_Button
              isPrimary={true}
              onClick={modal.hide}
              size={KC_ButtonSize.Large}
              type={KC_ButtonType.Button}
              text={tt("close")}
              className="d-flex"
            />
          </div>
        }
        header={<div style={{ padding: "12px 16px" }}></div>}
      >
        <div className="p-4 mktgauto-preview-img-container">
          <img className="mktgauto-preview-img" src={img} />
        </div>
      </KC_Modal_2>
    );
  }
);

export default EmailTemplate;
